import { Device } from "fhir/r4";
import { FunctionComponent, useEffect, useRef, useState } from "react";
import { Button, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

/**
 * Has to be used inside a Form component. Use configuration displayed below to enable validation.
 * 
 * <Form noValidate validated={validated}>
 * 
 * @param props properties for the component.
 * @returns the rendered Elements.
 */
const DeviceForm: FunctionComponent<{
    submitTrigger?: number,
    resetTrigger?: number,
    displayButtons?: boolean,
    deviceSubmit: (device: Device) => void
}> = (props) => {
    const { t } = useTranslation();
    const submitDeviceRef = useRef<() => void>(() => undefined);
    submitDeviceRef.current = generateAndSubmitDevice;

    useEffect(() => {
        if (props.resetTrigger) {
            onReset();
        }
    }, [props.resetTrigger]);

    useEffect(() => {
        if (props.submitTrigger) {
            submitDeviceRef.current();
        }
    }, [props.submitTrigger]);

    const [form, setForm] = useState({
        name: '',
        identifier: '',
    });

    const handleChange = (event: { target: { name: any; value: any; }; }) => {
        setForm({ ...form, [event.target.name]: event.target.value });
    }

    const onSubmit = (event: any) => {
        const formtv = event.currentTarget;
        if (formtv.checkValidity() === true) {
            generateAndSubmitDevice();
        }
    }

    function generateAndSubmitDevice() {
        const device = {
            "resourceType": "Device",
            "id": "1-CDL",
            "status": "active",
            "deviceName": [
                {
                    "name": form.name,
                    "type": "user-friendly-name"
                }
            ],
            "udiCarrier": [
                {
                    "deviceIdentifier": form.identifier
                }
            ]
        } as Device;

        props.deviceSubmit(device);
    }

    const onReset = () => {
        setForm({
            name: '',
            identifier: '',
        });
    }

    return <><Form.Group
        className="col"
    >
        <Form.Label>{t("forms.common.name")} :</Form.Label>
        <Form.Control
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            className="form-control"
            required />
        <Form.Control.Feedback type="invalid">
            {t("forms.device.invalidName")}
        </Form.Control.Feedback>
    </Form.Group>

        <Form.Group
            className="col"
        >
            <Form.Label>{t("forms.common.identifier")} :</Form.Label>
            <Form.Control
                type="text"
                name="identifier"
                value={form.identifier}
                onChange={handleChange}
                className="form-control"
                required />
            <Form.Control.Feedback type="invalid">
                {t("forms.device.invalidIdentifier")}
            </Form.Control.Feedback>
        </Form.Group>

        {props.displayButtons &&
            <Row className="mb-3">
                <Form.Group className="col">

                    <Button
                        className="button"
                        variant="danger"
                        onClick={onSubmit}
                    >
                        {t("forms.common.submit")}
                    </Button>
                    <Button
                        className="button"
                        variant="secondary"
                        onClick={onReset}
                    >
                        {t("forms.common.reset")}
                    </Button>
                </Form.Group>
            </Row>
        }
    </>;
};

export default DeviceForm;
